import React, { useEffect, useState } from 'react';
import API from './components/helpers/endpointservice';
import axios from 'axios';
import { useNavigate } from 'react-router';
import { HOME } from './components/helpers/routerPaths';
import { PulseLoader } from 'react-spinners';
import LoaderVisible from './components/helpers/loader';

const Login = () => {
    const nav = useNavigate()
    const userMail = JSON.parse(localStorage.getItem("userDataDecode"))?.email
    const [isLoginLoader, setLoginLoader] = useState(false)

  useEffect(() => {
    if (userMail) {
      setLoginLoader(true)
      const userDetails = localStorage.getItem("userData");
      let userToken = JSON.parse(userDetails);
      let loginApiUrl = `${API.GET_USER}?email=${userMail}`;
        axios({
          method: "GET",
          url: loginApiUrl,
          headers: {
            'Authorization': "Bearer " + userToken.id_token
          }
        })
          .then((response) => {
            setLoginLoader(false)
            if(response.status === 200){
              if(response.data) {
                localStorage.setItem("Role", response?.data?.roleName || [])
                localStorage.setItem("UserId", response?.data?.id)
                // localStorage.setItem("Role", response?.data?.roleName.toLowerCase() || "")
                nav(HOME)
             }
            }
        })
        .catch((error) => {
          
          setLoginLoader(false)
            localStorage.setItem("isUserValid", false)
            localStorage.clear();
            window.location.href = process.env.REACT_APP_LOGOUT;
        });
    
      } 
    },[userMail])

  return (
    <>  
     {/* { isLoginLoader &&
      <div className='loader'>    
           <div className="spinner_overlay">
              <div className="loader">
                <PulseLoader color="#D12232" size={10} speedMultiplier={1} />
              </div>
            </div>
      </div>} */}
      <LoaderVisible isLoader={isLoginLoader} />
    </>
  );
};

export default Login;
